module.exports = __webpack_public_path__ + "static/img/hyper-tube-entrance_256.28f4787.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hyper-tube-entrance_256.png
// module id = Mjn0
// module chunks = 0